"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => ({
    editor: {
        fontSize: 14,
        fontWeight: 500,
        // backgroundColor: 'white',
        width: '100%',
        padding: '0 6px',
        '& *': {
            lineHeight: '2em',
            minHeight: '2em',
        },
        '& ul, & ol': {
            marginLeft: '20px',
        },
    },
    active: {
        backgroundColor: theme.palette.editing,
    },
}));
//# sourceMappingURL=rich-editor-styles.js.map